export default "/images/2da06a1ca70ee03ccb5e55c2f1411658.avif";